document.addEventListener("DOMContentLoaded", function () {
	// Highlight the bootstrap accoridion item in the add artwork section of the order process
	const accordionItems = document.querySelectorAll(".accordion-item");
	accordionItems.forEach((item) => {
		const button = item.querySelector(".accordion-button");
		button.addEventListener("click", function () {
			accordionItems.forEach((accordionItem) => {
				const accordionButton = accordionItem.querySelector(".accordion-button");
				if (accordionButton.getAttribute("aria-expanded") === "true") {
					accordionItem.classList.add("border", "border-3");
				} else {
					accordionItem.classList.remove("border", "border-3");
				}
			});
		});
	});
	
	// get price break data
	const pricingDataElement = document.getElementById("pricingData");
	const pricingJson = pricingDataElement.getAttribute("data-pricing");
	let priceBreaks = [];
	const qtyInput = document.getElementById('js-qty-input');
	const currentPriceDisplay = document.getElementById('js-current-price');

	if (pricingJson) {
		const priceBreaksJson = JSON.parse(pricingJson);
		priceBreaks = priceBreaksJson[0].Breaks;
	}
	
	// find price break
	function findClosestPrice(qty) {
		let price = '';
		
		for (let i = 0; i < priceBreaks.length; i++){
			// If input quantity is less than the first break point, return the first price
			if (qty < priceBreaks[0].Quantity) {
				price = priceBreaks[0].Price;
				break;
			}
			
			// If quantity matches exactly
			if (qty === priceBreaks[i].Quantity) {
				price = priceBreaks[i].Price;
				break;
			}

			// If within a range, use the previous price
			if (i < priceBreaks.length - 1 && qty >= priceBreaks[i].Quantity && qty < priceBreaks[i + 1].Quantity) {
				price = priceBreaks[i].Price;
				break;
			}

			// If greater than or equal to the highest break, use last price
			if (qty >= priceBreaks[priceBreaks.length - 1].Quantity) {
				price = priceBreaks[priceBreaks.length - 1].Price;
				break;
			}
		}
		
		return price;
	}
	
	// get initial input value and set inital value to display
	currentPriceDisplay.innerText = findClosestPrice(parseInt(qtyInput.value, 10) || 0).toFixed(2);
	
	
	// quantity input
	qtyInput.addEventListener("input", function () {
		const qty = parseInt(this.value, 10) || 0;
		const price = findClosestPrice(qty);
		currentPriceDisplay.innerText = price.toFixed(2);
	});
	
});
